export default __webpack_public_path__ + "static/media/partners17.0a5a3003.png";